import { RoutingPath } from "@core/enums/routing-path";

export interface NavItem {
  readonly labelKey: string;
  readonly icon: string;
  readonly link: Array<string>;
}

/** The rail's destinations. */
export const SHELL_NAV_ITEMS: ReadonlyArray<NavItem> = [
  {
    labelKey: "GROUPS",
    icon: "admin_panel_settings",
    link: [`/${RoutingPath.Groups}`],
  },
  {
    labelKey: "employees.title",
    icon: "badge",
    link: [`/${RoutingPath.Employees}`],
  },
];

/**
 * The translation key of the page a URL belongs to - the nav item whose link
 * is the URL's first segment - or "" outside the shell (e.g. the login page).
 * Used for the top bar's title and for where a notification was raised.
 */
export function pageLabelKeyFor(url: string): string {
  const first = url.split(/[?#]/)[0].split("/")[1] ?? "";
  return (
    SHELL_NAV_ITEMS.find(
      (item: NavItem): boolean => item.link[0] === `/${first}`
    )?.labelKey ?? ""
  );
}
